import React from "react";
import { useLocation } from "react-router-dom";
import CheckoutForm from "./checkoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Helmet } from "react-helmet";

const stripePromise = loadStripe(
  "pk_test_51StxRy1ilWNnlalf9SjVqO0KzCNv3F8Ognvd2r1EUdjBuNUg9hXZ2I6F6SKKIhSM8Q6VWza52L01XzgKsfqC0jCI00j0H42BYM"
);

function Checkout() {

  const location = useLocation();
  const { subscriptionData } = location.state || {};

  console.log("subscriptionData:", subscriptionData);

 

  return (
    
    <Elements stripe={stripePromise}>
  <Helmet>
  <title>Secure Checkout – PrepNexis AI-Powered PTE Practice</title>
  <meta
    name="description"
    content="Complete your PrepNexis purchase securely. Get access to AI-powered PTE mock tests, real-time scoring, and personalized feedback to boost your exam prep."
  />
  <meta
    name="keywords"
    content="PrepNexis checkout, PTE mock test payment, secure PTE practice, PTE plan purchase, AI PTE exam prep"
  />
  <meta name="robots" content="noindex, nofollow" />
  <meta name="author" content="PrepNexa Team" />
  <link rel="canonical" href="https://prepnexis.com/checkout" />

  {/* Open Graph Tags */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Secure Checkout – PrepNexis AI-Powered PTE Practice" />
  <meta
    property="og:description"
    content="Finish your purchase and unlock full access to PrepNexis’s PTE prep tools, mock tests, and instant scoring system."
  />
  <meta property="og:url" content="https://prepnexis.com/checkout" />
  <meta property="og:image" content="https://prepnexis.com/images/checkout-banner.png" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Secure Checkout – PrepNexis" />
  <meta
    name="twitter:description"
    content="Fast and secure checkout to access AI-powered PTE mock tests and real-time scoring with PrepNexis."
  />
  <meta name="twitter:image" content="https://prepnexis.com/images/checkout-banner.png" />
</Helmet>

      <CheckoutForm subscriptionData={subscriptionData}/>
    </Elements>
  );
}

export default Checkout;
